import * as React from "react";

import { Icons } from ".";
import { toast } from "react-toastify";
import API from "src/services/api";

interface IQRProps extends React.HTMLProps<HTMLElement> {
  url: string;
}
interface IQRState {
  code: string;
  error: boolean;
}

class QR extends React.Component<IQRProps, IQRState> {
  state: IQRState = {
    code: "",
    error: false,
  };

  async componentDidMount() {
    const { url } = this.props;
    if (url) {
      try {
        const code = await API.LINK.getQR(url);
        this.setState({ code });
      } catch (err) {
        this.setState({ error: true });
      }
    }
  }

  qrClipboard(blob: Blob) {
    if (typeof ClipboardItem === "undefined") {
      console.warn("ClipboardItem is not supported in this browser.");
      toast.error("Copy failed: not supported in your browser", {
        autoClose: 1200,
      });
      return;
    }

    try {
      const data = [new ClipboardItem({ "image/png": blob })];
      navigator.clipboard.write(data);
      console.log("Image copied to clipboard successfully!");
      toast.success("QR code copied", { autoClose: 1200 });
    } catch (err) {
      console.error("Failed to copy image: ", err);
      toast.error("Copy failed: not supported in your browser", {
        autoClose: 1200,
      });
    }
  }

  dataUrlToBlob(dataUrl: string) {
    // Split into "data:[mime];base64," and the actual base64 string
    const parts = dataUrl.split(",");
    // Extract the MIME type from the first part, e.g. "data:image/png;base64"
    const mimeMatch = parts[0].match(/:(.*?);/);
    if (!mimeMatch) {
      throw new Error("Could not extract MIME type.");
    }
    const mime = mimeMatch[1];

    // Decode Base64 into a binary string
    const base64String = atob(parts[1]);
    // Create a Uint8Array from the binary string
    const length = base64String.length;
    const u8arr = new Uint8Array(length);
    for (let i = 0; i < length; i++) {
      u8arr[i] = base64String.charCodeAt(i);
    }

    // Create a Blob with the array buffer and the MIME type
    return new Blob([u8arr], { type: mime });
  }

  handleQrClick = (code: string) => () => {
    const blob = this.dataUrlToBlob(code);
    this.qrClipboard(blob);
  };

  render() {
    const { className } = this.props;
    const { code, error } = this.state;
    return (
      <button
        className={`relative leading-none inline-block align-middle group py-1 px-1 border border-transparent text-right rounded focus:outline-none ${
          code && !error ? "hover:bg-white hover:border-grey-dark" : ""
        } ${!code && !error ? "loader" : ""} ${error ? "text-red" : ""} ${
          className || ""
        }`}
        onClick={this.handleQrClick(code)}
        disabled={!code}
      >
        <Icons.QR className={!code ? "opacity-50" : ""} />
        {code && (
          <div className="tooltip tooltip--bottom tooltip--right absolute z-30 hidden group-hover:block w-32 bg-white shadow-md border border-grey-dark py-3 px-3">
            <img src={code} alt="QR code" className="align-bottom w-full" />
          </div>
        )}
      </button>
    );
  }
}

export default QR;



// WEBPACK FOOTER //
// ./src/components/QR.tsx